export default class {
    constructor (SURVEY_GROUP_TYPE_ENUM, COURSE_TRAINING_PASSING_TYPE_ENUM, COURSE_PROGRESS_STATUS_TYPE_ENUM) {
        this.SURVEY_GROUP_TYPE_ENUM = SURVEY_GROUP_TYPE_ENUM;
        this.COURSE_TRAINING_PASSING_TYPE_ENUM = COURSE_TRAINING_PASSING_TYPE_ENUM;
        this.COURSE_PROGRESS_STATUS_TYPE_ENUM = COURSE_PROGRESS_STATUS_TYPE_ENUM;
    }

    isCourseSurveyType (surveyGroup) {
        return surveyGroup.type === this.SURVEY_GROUP_TYPE_ENUM.KEYS.COURSE_SURVEY;
    }

    isFixedTypePreviousTrainingPassed (currentTrainingId, myTrainings) {
        let hasPreviousMandatoryTrainingPassed = true;
        myTrainings.forEach((myTraining, index) => {
            if (currentTrainingId === myTraining.trainingId) {
                hasPreviousMandatoryTrainingPassed = this.hasPreviousMandatoryTrainingPassed(index - 1, myTrainings);
            }
        });
        return hasPreviousMandatoryTrainingPassed;
    }

    /**
     * Find previous training passing type in case training is MANDATORY
     * @param index
     * @param myTrainings
     * @returns {*|boolean}
     */
    hasPreviousMandatoryTrainingPassed (index, myTrainings) {
        if (index < 0) {
            return true;
        }

        for (let counter = index; counter >= 0; counter--) {
            if (myTrainings[counter].trainingPassingType === this.COURSE_TRAINING_PASSING_TYPE_ENUM.KEYS.MANDATORY) {
                return myTrainings[counter].progress && myTrainings[counter].progress.status === this.COURSE_PROGRESS_STATUS_TYPE_ENUM.KEYS.PASSED;
            }
        }

        return true;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/survey/group/index.js